import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Params } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Api } from 'src/app/shared/constants/api';
import { DataService } from 'src/app/shared/services/data.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { IEntityGroup, IEntityGroupCriteria } from '../external-entity.interface';

@Component({
    selector: 'app-view-linked-companies',
    templateUrl: './view-linked-companies.component.html',
    styleUrls: ['./view-linked-companies.component.less'],
    standalone: false
})
export class ViewLinkedCompaniesComponent implements OnInit {

  constructor(private logger:NGXLogger,private activatedRoute:ActivatedRoute,
              private utilityService:UtilityService,private dailogRef:MatDialogRef<ViewLinkedCompaniesComponent>,
              @Inject(MAT_DIALOG_DATA) public data:any,private service:DataService) { }

  pageSizeOptions=this.utilityService.getPageSizeOptions();
  criteria:IEntityGroupCriteria={};
  totalRecords:any;
  companies: IEntityGroup[] = [];
  companyColumns=['code','name'];
  ngOnInit(): void {
    this.criteria.groupId=this.data;
    this.getLinkedCompanies();
  }

  sortData(event:any){
    this.criteria.sort=[event.active,event.direction];
    this.getLinkedCompanies();
  }

  onCancel(){
    this.dailogRef.close();
  }

  getLinkedCompanies(){
    this.service.get(Api.EXTERNAL_ENTITY,this.criteria).subscribe(res => {
      this.companies = res.contents || [];
    })
  }
}
